import React, { useEffect, useRef } from 'react'

export const useCurrentLocation = ({ pathViews }) => {

  const previous = useRef({ ...pathViews })

  const currentDepth = _.size(pathViews)
  const previousDepth = useRef(currentDepth)
  const returnedFromDeeperRoute = currentDepth < previousDepth.current

  const isNewPage = (key) => {
    return pathViews[key] !== previous.current[key]
  }

  useEffect(() => {
    previousDepth.current = currentDepth
  }, [currentDepth])

  useEffect(() => {
    previous.current = { ...pathViews }
  }, [pathViews])

  return { isNewPage, returnedFromDeeperRoute }
}